
<script>
import ObjectImage from "@/components/object-image.vue";
import {formatDate} from "@/services/functions";

export default {
    name: "section-blog",
    methods: {formatDate},
    components: {ObjectImage},
    props: {
        posts: {
            type: Object,
            required: true
        }
    },
    mounted() {
    },
}
</script>

<template>
    <div class="row" v-if="posts">
        <article class="col-md-4" v-for="(post, index) in posts" :key="index">
            <RouterLink :to="'blog/' + post.slug" class="d-block">
                <object-image v-if="post && post._embedded && post._embedded['wp:featuredmedia']?.[0]" :image="post._embedded['wp:featuredmedia']?.[0]"/>
                <time :datetime="post.date" v-if="post && post.date" class="d-block mb-10 mt-10">
                    {{ formatDate(post.date) }}
                </time>
                <h3 class="mt-10 mb-20 text-size-medium font-weight-bold text-uppercase" v-if="post && post.title">{{ post.title.rendered }}</h3>
                <div v-if="post && post.excerpt" v-html="post.excerpt.rendered" class="mb-40"></div>
            </RouterLink>
        </article>
    </div>
</template>

<style scoped lang="scss">

</style>
